<div>
  <span class="flex">
      <label class="mb-1 block font-medium {{!readonly && required ? requiredClasses : ''}}" *ngIf="label"
             [ngClass]="{ disabled: isDisabled }">{{ label }}</label>
      <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                     [sizeInPx]="infoIconSize"></psc-info-icon>
  </span>
  <psc-readonly-value
    *ngIf="readonly"
    [value]="value">
  </psc-readonly-value>
  <ng-container *ngIf="!readonly">
    <div class="flex items-center" *transloco="let t">
      <input
        matInput
        [matDatepicker]="picker"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        class="{{inputClasses}}"
        placeholder="{{ placeholder || t('placeholders.date_input') }}"
        [disabled]="isDisabled"/>
      <mat-datepicker-toggle class="-ml-[50px]" [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </ng-container>

  <psc-input-error
    [control]="formControl"></psc-input-error>
</div>
